module.exports = __webpack_public_path__ + "img/00021.fe97cf19.webp";